import { useMemo } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { groupByHouse, excludeStaff } from "../../utils/timetableUtils";
import HouseCard from "../cards/HouseCard";

export default function ResidentialLane({
  residents = [],
  selectedDate,
  selectedCampusId,
  onOpenBedrooms,
  onOpenTransfers,
  onOpenTransport,
  onOpenStaffSchedule,
  tv = false,
  tvColumns = 3,
  tvCardRange = null,
}) {
  // TV view drops our own staff from the list (they're not group members to track here).
  const grouped = useMemo(
    () => groupByHouse(tv ? excludeStaff(residents) : residents),
    [residents, tv]
  );

  const orderedGroups = useMemo(() => {
    return Object.entries(grouped).sort(([houseA], [houseB]) => {
      const aUnassigned =
        String(houseA || "").trim().toLowerCase() === "unassigned";
      const bUnassigned =
        String(houseB || "").trim().toLowerCase() === "unassigned";

      if (aUnassigned && !bUnassigned) return -1;
      if (!aUnassigned && bUnassigned) return 1;

      return String(houseA).localeCompare(String(houseB));
    });
  }, [grouped]);

  return (
    <Box>
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", md: "center" }}
        spacing={1}
        sx={{ mb: 2 }}
      >
        <Typography variant="h6">Residential</Typography>

        {tv ? null : (
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography
            variant="body2"
            sx={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={() => onOpenTransfers?.(selectedDate)}
          >
            Open Transfers →
          </Typography>

          <Typography
            variant="body2"
            sx={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={() => onOpenBedrooms?.(selectedDate, selectedCampusId)}
          >
            Open Bedrooms →
          </Typography>

          <Typography
            variant="body2"
            sx={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={() => onOpenTransport?.(selectedDate, selectedCampusId)}
          >
            Open Transport →
          </Typography>

          {onOpenStaffSchedule && (
            <Typography
              variant="body2"
              sx={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() => onOpenStaffSchedule(selectedDate, selectedCampusId)}
            >
              Open Staff Scheduling →
            </Typography>
          )}
        </Stack>
        )}
      </Stack>

      <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
        {(tvCardRange ? orderedGroups.slice(tvCardRange[0], tvCardRange[1]) : orderedGroups).map(([house, people], i) => {
          const index = i + (tvCardRange ? tvCardRange[0] : 0);
          return (
            <HouseCard
              key={house || `house-${index}`}
              house={house}
              residents={people}
              selectedDate={selectedDate}
              colorIndex={index}
              tv={tv}
              tvColumns={tvColumns}
            />
          );
        })}
      </Stack>
    </Box>
  );
}